import { ObjectizerModel } from '@leverege/condition';
import { ns } from '@leverege/i18n';
import { Toast } from '@leverege/ui-elements';
const {
  t,
  tIcon
} = ns('condition.PasteRuleAction');
export default {
  id: 'condition.objectizer.PasteRuleAction',
  matches: {
    client: 'condition.ObjectizerEditor',
    use: 'objectizerActionBar'
  },
  layout: {
    group: ['more'],
    groupIcons: ['fa fa-ellipsis-v fa-fw'],
    sort: 'paste'
  },
  appearance(context) {
    return {
      name: t('name'),
      icon: tIcon('icon', 'fa fa-paste fa-fw')
    };
  },
  handles(context) {
    return true;
  },
  perform: async ({
    context
  }) => {
    const {
      onChange,
      eventData,
      value: rule
    } = context;
    try {
      const [res] = await navigator.clipboard.read();
      const type = await res.getType('text/plain');
      const value = JSON.parse(await type.text());
      if (rule != null && value.type !== rule.type) {
        throw new TypeError('Invalid model type pasted into objectizer');
      }
      onChange({
        value,
        eventData
      });
    } catch (err) {
      console.error(err);
      Toast.error([t('parseErrorTitle'), t('parseErrorDescription')]);
    }
  }
};